import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  tileVendor: {
    textTransform: 'uppercase',
    fontWeight: '700',
  },
  tile: {
    padding: '20px',
    width: '30%',
    minWidth: '10rem',
    flex: 1,
  },
  border: {
    outline: 'solid',
    outlineColor: theme.palette.primary.main,
    outlineOffset: '-5px',
  },
}));
